export default "__VITE_ASSET__1AVEvQ0q__"